var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper pr"},[_c('NewsClassItem',{on:{"newsClass":_vm.selNewsClass}}),_c('div',{staticClass:"wrap-form"},[_c('NewsArticleList',{ref:"table",attrs:{"classCode":_vm.classCode,"className":_vm.className}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }